import Applet from "../Applet";
import PlatformDetailSearch from "../../../components/PlatformDetailSearch";

class SimpleSearchFormApplet extends Applet {
    state = {
        Name: "SimpleSearchFormApplet"
    };

    constructor(props) {
        super(props);

        this.state.Controls = props.controls;
        this.state.Actions = props.actions;
    };

    render() {
        // Forwarded, not owned: the search form gathers the criteria and the TABLE runs the
        // query, so the table has to arrive intact at PlatformDetail.searchHandler.
        return <PlatformDetailSearch applet={this}
                                embeddedParent={this.props.embeddedParent}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Search"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default SimpleSearchFormApplet;
